var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.314,
    height: 11.314
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 990",
    d: "M.604 6.263a.855.855 0 010-1.21.859.859 0 011.212-.003l3.84 3.84 3.836-3.836a.86.86 0 011.213-.004.863.863 0 01-.001 1.216L6.26 10.71a.859.859 0 01-1.212-.003z"
  })));
}
export default SvgArrowDown;